<article class="logo-slider">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10">
        <div class="logo-slider__headline">
          {{ "LOGO_SLIDER.HEADLINE" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="logo-slider__wrapper">
    <div class="logo-slider__line">
      <div class="logo-slider__logo-wrapper" *ngFor="let logo of randomLogos">
        <img [src]="'/assets/img/home-logos/' + logo[0]" #logoImage [alt]="logo[1] | translate" />
      </div>
    </div>
    <div class="logo-slider__line logo-slider__line--duplication">
      <div class="logo-slider__logo-wrapper" *ngFor="let logo of randomLogos">
        <img [src]="'/assets/img/home-logos/' + logo[0]" #logoImage [alt]="logo[1] | translate"/>
      </div>
    </div>
  </div>

  <div class="logo-slider__cta-wrapper">
    <a routerLink="/anbieter" class="logo-slider__cta animline animline--black">{{ "LOGO_SLIDER.LINK_TEXT" | translate }}</a>
  </div>

</article>
